export const common = {
  nav: {
    home: 'الرئيسية',
    features: 'المميزات',
    cases: 'حالات الذكاء الاصطناعي',
    workflow: 'سير العمل',
    contact: 'اتصل بنا',
    requestDemo: 'تجربة',
  },
  hero: {
    title: 'تحليل الصور الطبية بالذكاء الاصطناعي',
    subtitle: 'نظام تصوير طبي ذكي شامل للتحليل التلقائي لحالات متعددة بما في ذلك الكسور والتهاب المفاصل وتشوهات الرئة والجنف والحالات السنية',
    cta: 'ابدأ الآن',
    fdaCompliant: 'متوافق مع FDA',
    hipaaSecure: 'آمن HIPAA',
    confidence: 'الثقة',
    detected: 'تم الكشف',
  },
  features: {
    label: 'القدرات الأساسية',
    title: 'تقنية الكشف المتقدمة متعددة الحالات',
    subtitle: 'الاستفادة من أحدث تقنيات الذكاء الاصطناعي والرؤية الحاسوبية لتقديم تحليل سريع ودقيق وشامل للصور الطبية عبر حالات طبية متعددة للمهنيين الصحيين في جميع أنحاء العالم.',
    
    fracture: {
      title: 'كشف كسور العظام',
      description: 'يكتشف بدقة أنواع متعددة من كسور العظام بما في ذلك كسور الكوع والمعصم والكتف والعضد والساعد والأصابع مع تحديد دقيق للموقع.',
      metric: '6 أنواع من الكسور',
    },
    knee: {
      title: 'كشف التهاب مفصل الركبة',
      description: 'تحليل متقدم لتدهور مفصل الركبة، وتحديد مستويات شدة التهاب المفاصل والكشف المبكر عن تدهور الغضروف.',
      metric: '5 درجات شدة',
    },
    lung: {
      title: 'كشف تشوهات الرئة',
      description: 'تحليل شامل للأشعة السينية للصدر يكتشف انخماص الرئة وتضخم القلب والانصباب الجنبي والارتشاحات والعقيدات والكتل والالتهاب الرئوي واسترواح الصدر بدقة عالية.',
      metric: '8 حالات',
    },
    scoliosis: {
      title: 'كشف الجنف',
      description: 'يحدد تشوهات انحناء العمود الفقري ومستويات الشدة من صور الأشعة السينية.',
      metric: '4 مناطق العمود الفقري',
    },
    teeth: {
      title: 'كشف الأسنان',
      description: 'يكتشف جميع حالات الأسنان بما في ذلك التسوس والتيجان والحشوات والزرعات وفقدان العظام وكسور الأسنان باستخدام صور الأشعة السينية مع نموذج YOLOv8.',
      metric: '31 حالة أسنان',
    },
    cavity: {
      title: 'كشف التجاويف',
      description: 'يركز بشكل خاص على اكتشاف التجاويف مقابل الأسنان الطبيعية باستخدام صور سريرية حقيقية مع نموذج YOLOv8. يدعم JPEG/PNG مع تصور مربع الحدود.',
      metric: 'كشف في الوقت الفعلي',
    },
    annotated: {
      title: 'صور مشروحة',
      description: 'احصل على تعليقات توضيحية مرئية مفصلة تسلط الضوء على الحالات المكتشفة مع مربعات الحدود والتسميات.',
      metric: 'وضوح بصري',
    },
    api: {
      title: 'واجهة برمجة تطبيقات عالية الأداء',
      description: 'مبني باستخدام FastAPI للحصول على أداء سريع وقابل للتطوير وسهولة التكامل مع أنظمة الويب والهاتف المحمول والمستشفيات.',
      metric: 'تكامل سريع',
    },
  },
  cases: {
    badge: 'التطبيقات السريرية',
    title: 'حلول شاملة للتصوير الطبي',
    subtitle: 'أنظمة كشف متقدمة مدعومة بالذكاء الاصطناعي تغطي تخصصات طبية متعددة بدقة سريرية وقدرات تحليل فورية.',
    detectionTypes: 'أنواع الكشف',
    keyFeatures: 'الميزات الرئيسية',
    aiDetection: 'الكشف بالذكاء الاصطناعي نشط',
    tryDemo: 'جرب العرض التفاعلي',
    
    // Detection type translations
    detectionTypeLabels: {
      // Fracture types
      elbow: 'الكوع',
      wrist: 'المعصم',
      shoulder: 'الكتف',
      humerus: 'العضد',
      forearm: 'الساعد',
      finger: 'الإصبع',
      
      // Knee grades
      normal: 'طبيعي',
      doubtful: 'مشكوك فيه',
      minimal: 'خفيف',
      moderate: 'متوسط',
      severe: 'شديد',
      
      // Lung conditions
      atelectasis: 'انخماص الرئة',
      cardiomegaly: 'تضخم القلب',
      effusion: 'الانصباب الجنبي',
      infiltrates: 'الارتشاحات',
      nodules: 'العقيدات',
      masses: 'الكتل',
      pneumonia: 'الالتهاب الرئوي',
      pneumothorax: 'استرواح الصدر',
      
      // Dental conditions
      caries: 'التسوس',
      crown: 'التاج',
      filling: 'الحشوة',
      implant: 'الزرعة',
      boneLoss: 'فقدان العظام',
      fracture: 'الكسر',
      
      // Cavity detection
      cavity: 'التجويف',
      normalTooth: 'سن طبيعي',
      
      // Scoliosis regions
      cervical: 'عنقي',
      thoracic: 'صدري',
      lumbar: 'قطني',
      sacral: 'عجزي',
    },
    
    fracture: {
      title: 'كشف كسور العظام',
      description: 'نظام كشف الكسور في الوقت الفعلي يعتمد على YOLO يغطي مناطق تشريحية متعددة بدقة عالية وتوصيات سريرية.',
      detectionLabel: 'تم اكتشاف كسر في المعصم',
      feature1Title: 'الكشف الفوري',
      feature1Desc: 'تحديد فوري للكسور مع تحديد الموقع ودرجات الثقة.',
      feature2Title: 'تغطية متعددة المناطق',
      feature2Desc: 'تحليل شامل عبر 6 مناطق تشريحية رئيسية بما في ذلك الأطراف العلوية والسفلية.',
      feature3Title: 'التكامل السريري',
      feature3Desc: 'تكامل سلس مع PACS مع إعداد تقارير آلية وتوصيات علاجية.',
    },
    
    knee: {
      title: 'كشف التهاب مفصل الركبة',
      description: 'نظام تصنيف مدعوم بـ EfficientNet-B5 يصنف التهاب مفصل الركبة إلى 5 درجات شدة للتخطيط العلاجي الدقيق.',
      detectionLabel: 'الدرجة 3 التهاب متوسط',
      feature1Title: 'تصنيف 5 درجات',
      feature1Desc: 'تقييم دقيق للشدة من طبيعي إلى شديد باستخدام أنظمة تصنيف سريرية معتمدة.',
      feature2Title: 'تتبع التقدم',
      feature2Desc: 'تحليل طولي لمراقبة تقدم المرض وفعالية العلاج بمرور الوقت.',
      feature3Title: 'إرشادات العلاج',
      feature3Desc: 'توصيات قائمة على الأدلة للتدخلات المحافظة أو الجراحية بناءً على الشدة.',
    },
    
    teeth: {
      title: 'كشف حالات الأسنان',
      description: 'نظام ذكاء اصطناعي شامل للأسنان يكتشف 31 حالة مختلفة من الأشعة السينية البانورامية لتقييم صحة الفم الكامل.',
      detectionLabel: 'تم اكتشاف حالات متعددة',
      feature1Title: '31 نوع حالة',
      feature1Desc: 'تغطية كاملة لأمراض الأسنان والترميمات والأجهزة التقويمية في فحص واحد.',
      feature2Title: 'التحليل البانورامي',
      feature2Desc: 'تقييم الفم الكامل مع تحديد دقيق لكل حالة مكتشفة وترقيم الأسنان.',
      feature3Title: 'تخطيط العلاج',
      feature3Desc: 'رسم بياني آلي للأسنان وإنشاء خطة علاج شاملة لسير عمل فعال.',
    },
    
    scoliosis: {
      title: 'كشف الجنف',
      description: 'نظام تحليل متقدم لانحناء العمود الفقري يغطي 4 مناطق فقرية مع قياس زاوية كوب للتشخيص الدقيق.',
      detectionLabel: 'انحناء صدري 28 درجة',
      feature1Title: 'قياس زاوية كوب',
      feature1Desc: 'حساب آلي لزوايا انحناء العمود الفقري بدقة عالية وقابلية للتكرار.',
      feature2Title: '4 مناطق فقرية',
      feature2Desc: 'تحليل كامل للمناطق العنقية والصدرية والقطنية والعجزية للتقييم الشامل.',
      feature3Title: 'تصنيف الشدة',
      feature3Desc: 'تصنيف تلقائي من خفيف إلى شديد مع توصيات علاجية وبروتوكولات مراقبة.',
    },
  },
  workflow: {
    label: 'كيف يعمل',
    title: 'خط أنابيب التحليل بالذكاء الاصطناعي',
    steps: {
      step1: {
        title: 'تحميل الصورة الطبية',
        description: 'يقدم المستخدم الأشعة السينية أو الصورة الطبية',
      },
      step2: {
        title: 'كشف الذكاء الاصطناعي',
        description: 'يحلل النموذج ويكتشف الحالات',
      },
      step3: {
        title: 'توليد النتائج',
        description: 'درجات الثقة والتعليقات التوضيحية',
      },
      step4: {
        title: 'تحليل مفصل',
        description: 'تقييم شامل للحالة',
      },
      step5: {
        title: 'دليل العلاج',
        description: 'توليد التوصيات',
      },
      step6: {
        title: 'إرجاع النتائج',
        description: 'صورة مشروحة واستجابة JSON',
      },
    },
    stats: {
      analysisTime: 'وقت التحليل',
      accuracyRate: 'معدل الدقة',
      automatedService: 'خدمة آلية',
    },
  },
  cta: {
    title: 'هل أنت مستعد لتحويل سير عملك التشخيصي؟',
    subtitle1: 'انضم إلى أكثر من 500 منشأة صحية',
    subtitle2: 'تستخدم تحليل الصور الطبية بالذكاء الاصطناعي',
    button: 'طلب تجربة',
  },
  demo: {
    badge: 'تجربة تفاعلية',
    title: 'شاهده أثناء العمل',
    subtitle: 'اختبر قوة تحليل الصور الطبية المدعوم بالذكاء الاصطناعي عبر حالات متعددة',
    selectCase: 'اختر حالة الذكاء الاصطناعي',
    uploadTitle: 'تحميل صورة طبية',
    uploadDesc: 'اسحب وأفلت أو انقر للتحميل',
    fileFormats: 'PNG, JPG, DICOM',
    minSize: 'الحد الأدنى 224×224 بكسل',
    sampleImage: 'صورة نموذجية',
    analyzeButton: 'تحليل الصورة',
    analyzing: 'جاري التحليل...',
    results: 'نتائج التحليل',
    aiOutput: 'مخرجات تحليل الذكاء الاصطناعي',
    confidence: 'الثقة',
    location: 'الموقع',
    condition: 'الحالة',
    tryDemo: 'جرب التجربة',
    readyToAnalyze: 'جاهز للتحليل',
    readyToAnalyzeDesc: 'قم بتحميل صورة طبية وانقر على "تحليل الصورة" لرؤية نتائج الكشف بالذكاء الاصطناعي',
    cases: {
      fracture: 'كشف الكسور',
      knee: 'التهاب مفصل الركبة',
      lung: 'تشوهات الرئة',
      scoliosis: 'كشف الجنف',
      teeth: 'الحالات السنية',
      cavity: 'كشف التسوس',
    },
  },
  contact: {
    title: 'تواصل معنا',
    subtitle: 'هل لديك أسئلة؟ نحن هنا لمساعدتك في دمج حلنا المدعوم بالذكاء الاصطناعي',
    name: 'الاسم الكامل',
    email: 'عنوان البريد الإلكتروني',
    message: 'رسالتك',
    send: 'إرسال الرسالة',
    sendWhatsApp: 'إرسال عبر واتساب',
    info: {
      title: 'معلومات الاتصال',
      email: 'info@5vix.com',
      phone: '+20 1044553254',
    },
    businessHours: {
      title: 'ساعات العمل',
      weekdays: 'الاثنين - الجمعة: 9:00 صباحاً - 6:00 مساءً',
      saturday: 'السبت: 10:00 صباحاً - 4:00 مساءً',
      sunday: 'الأحد: مغلق',
    },
  },
  footer: {
    newsletter: {
      title: 'ابق على اطلاع',
      subtitle: 'احصل على آخر التحديثات حول تقنية الذكاء الاصطناعي الطبية',
      placeholder: 'اكتب رسالتك',
      button: 'اشترك',
    },
    sendWhatsApp: 'إرسال عبر واتساب',
    quickLinks: 'روابط سريعة',
    contact: 'اتصل بنا',
    copyright: '© 2025 5vix. جميع الحقوق محفوظة.',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الخدمة',
    poweredBy: 'مدعوم من Debug',
  },
};
